import React from "react";
import { Package } from "lucide-react";

export default function UnitsChips({ units = [], testId = "wallet-units" }) {
  if (!units.length) return null;
  return (
    <div className="flex gap-1.5 flex-wrap" data-testid={testId}>
      {units.map((u) => (
        <span key={u.item_id} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs bg-[#0F766E]/10 text-[#0F766E] border border-[#0F766E]/20" data-testid={`unit-${u.item_id}`}>
          <Package size={11}/> {u.remaining} {u.item_name} prepagati
        </span>
      ))}
    </div>
  );
}
